import {useState,React} from 'react';
import DownloadButton from '../buttons/DownloadButton';  // Import the DownloadButton component
import FilterModalTelegram from '../popups/FilterModalTelegram';
import { FilterIcon } from '../icons';

function TelegramDashboard() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const csvFileUrl = `${process.env.PUBLIC_URL}/telegram_v1.csv`;
    
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    return (
        <div className="dashboard-actions">
            <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                <FilterIcon />
                Filter By
            </button>
            <DownloadButton
                label="Download Telegram Data"
                fileUrl={csvFileUrl}
            />
            {isModalOpen && <FilterModalTelegram onToggle={toggleModal} />}
        </div>
    );
}

export default TelegramDashboard;
